import { HttpStatusCode } from "../models/HttpStatusCodes";
import { AlertTypes } from "../models/Enums";
import filesService from "./files.service";
import http from "./httpRequest";

class ProjectConstancyService {

    /**
   * Descargar ZIP de constancias por proyecto
   */
    async downloadConstancies(data: any) {
        try {
            const response = await http.post(
                "/project-constancies/zip",
                data,
                { responseType: "blob" }
            );

            if (response.status === HttpStatusCode.NoContent) {
                http.apiResponse.showError(
                    "[204] No hay proyectos en el periodo seleccionado.",
                    AlertTypes.WARNING
                );
                return;
            }

            if (response.status !== HttpStatusCode.Ok) {
                http.apiResponse.showError(
                    "No se pudo generar el archivo de constancias.",
                    AlertTypes.ERROR
                );
                return;
            }

            filesService.processFileToDownload(
                response,
                "constancias_proyectos_" + data.option.period + ".zip"
            );

        } catch (error: any) {
            http.apiResponse.showError(
                error?.response?.data?.message ||
                "Error inesperado al descargar constancias.",
                AlertTypes.ERROR
            );
        }
    }

    /**
   * Enviar constancias por correo (por periodo)
   */
    async sendConstancies(data: any) {
        try {
            const response = await http.post<any>(
                "/project-constancies/send",
                data
            );

            if (!response.data?.success) {
                http.apiResponse.showError(
                    response.data?.message ||
                    "No se pudieron enviar las constancias.",
                    AlertTypes.ERROR
                );
                return;
            }

        } catch (error: any) {
        http.apiResponse.showError(
            error?.response?.data?.message ||
            "Error inesperado al enviar constancias.",
            AlertTypes.ERROR
        );
    }
    }
}

export default new ProjectConstancyService();
